<template>
  <section class="top-header-menu" :class="{ [menuClass]: menuClass }">
    <div class="left-action">
      <slot name="left"></slot>
      <section v-if="!noHelp">
        <router-link v-if="hasHelp" :to="helpLink">
          <icon icon="#cx-hea1-help" />
        </router-link>
        <button v-else class="disabled-button">
          <icon icon="#cx-hea1-help" />
        </button>
      </section>
    </div>
    <div class="center-info">
      <slot></slot>
    </div>
    <div class="right-action">
      <slot name="right"></slot>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'TopHeaderMenuWrapper',

  props: {
    menuClass: String,
    noHelp: Boolean,
  },

  data() {
    return {
      routeIndex: null,
    };
  },

  computed: {
    ...mapState('help', ['help']),

    matchedRoute() {
      return this.routeIndex !== null ? this.$route.matched[this.routeIndex] || null : null;
    },

    matchedRouteName() {
      return this.matchedRoute?.name || 'unknown';
    },

    normalizedRoute() {
      if (!this.matchedRoute) return '';

      // 1. Clean base path (remove leading slash and '/help' suffix)
      let path = this.matchedRoute.path.replace(/^\//, '').replace(/\/help$/, '');

      // 2. Replace dynamic segments like :id with actual values
      path = path.replace(/:([a-zA-Z0-9_]+)/g, (_, paramName) => {
        return this.$route.params[paramName] || paramName;
      });

      // 3. Remove numeric segments and segments containing '?'
      path = path
        .split('/')
        .filter((segment) => {
          return !/^\d+$/.test(segment) && !segment.includes('?');
        })
        .join('/');

      return path;
    },

    hasHelp() {
      return !!this.help[this.normalizedRoute];
    },

    helpLink() {
      if (!this.matchedRouteName) return '#';

      const helpRouteName = `${this.matchedRouteName}-help`;

      if (this.$router.hasRoute(helpRouteName)) {
        return { name: helpRouteName };
      }

      const cleanPath = this.matchedRoute?.path?.replace(/\/help$/, '').replace(/\/$/, '') || '';
      return `${cleanPath}/help`;
    },
  },

  mounted() {
    this.$nextTick(() => {
      let el = this.$el;

      // Traverse up until you find the closest .screen ancestor
      while (el && !el.classList?.contains('screen')) {
        el = el.parentElement;
      }

      if (el) {
        const allScreens = Array.from(document.querySelectorAll('.screen'));
        this.routeIndex = allScreens.indexOf(el);
        if (this.$route.path.includes('reports/reservations')) {
          this.routeIndex++;
        }
      } else {
        console.warn('TopHeaderMenuWrapper could not find enclosing .screen');
      }
    });
  },
};
</script>
